import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, MultiselectCommand } from '../../../core/model/command';
import { Observable } from 'rxjs';
import { vacantRentalObjectCommand } from '../../model/const/command';
import { VacantOtherService } from '../data/vacant-other.service';

@Injectable()
export class VacantOtherExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: VacantOtherService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === vacantRentalObjectCommand.exportToExcel && command.itemsSource.length > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.export(command.items.map(item => item.id)).pipe(
        map(file => {
          this._nativeWindow.saveWithDecodedFileName(file);
        })
      );
    }
  }
}
